import { withStyles } from '@material-ui/core';
import React from 'react';
import * as styles from './styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'

interface Props {
    planLogs: string[];
}

export const CollapsePlans = ({ planLogs }: Props) => { 

    const [expanded, setExpanded] = React.useState<Array<string>>([])

    const Accordion = withStyles(styles.accordianStyles)(MuiAccordion)
    const AccordionSummary = withStyles(styles.AccordionSummaryStyles)(MuiAccordionSummary)
    const AccordionDetails = withStyles(styles.AccordionDetailStyles)(MuiAccordionDetails)
    const handleChange = (panel) => (event, newExpanded) => {
        if (expanded.indexOf(panel) > -1) {
            setExpanded(expanded.filter((a) => a != panel))
        } else {
            setExpanded([...expanded, panel])
        }
    }
    
    const printCleanedLog = (line: string) => {
        // Remove all text before the first "-" (including the "-")
        const idx = line.indexOf('- ');
        return idx !== -1 ? line.slice(idx + 1).trim() : line;
    }

  
    // Split planLogs into groups by the string after "plan-" and before "@"
    const planLogGroups: { [key: string]: string[] } = {};

    planLogs.forEach(line => { 
        const match = line.match(/plan-(.*?)@/);
        if (match) {
            const key = match[1];
            if (!planLogGroups[key]) {
                planLogGroups[key] = [];
            }
            planLogGroups[key].push(line);
        }
    });
    return (
        <div style={{ border: '1px solid #eee' }}>
           { Object.keys(planLogGroups).map((key) => {
                let lastLine = printCleanedLog(planLogGroups[key][planLogGroups[key].length-1]);
                if (lastLine.includes('incentives')) {
                    lastLine = printCleanedLog(planLogGroups[key][planLogGroups[key].length-2]);
                }
                return (
                    <Accordion
                        square
                        expanded={expanded.indexOf(key) > -1}
                        onChange={handleChange(key)}
                        key={key}
                    >  
                        <AccordionSummary aria-controls={`${key}-content`} id={`${key}-header`}>
                            <h2>Plan - {key} - {lastLine} </h2>
                        </AccordionSummary>
                        <AccordionDetails>
                            {planLogGroups[key].map((line, index) => (
                                <div key={index} style={{ fontSize: '13px' }}>
                                    {printCleanedLog(line)}
                                </div>
                            ))}
                        </AccordionDetails>    
                    </Accordion>
                )
            })}     
        </div>
    )
}